<main class="dashboard">
  <section class="panel filters">
    <label
      >Date<input
        type="date"
        [value]="selectedDate()"
        (change)="selectedDate.set($any($event.target).value)" /></label
    ><label
      >Schedule Type<select
        [value]="scheduleType()"
        (change)="scheduleType.set($any($event.target).value)"
      >
        <option>Day Ahead</option>
        <option>Intraday </option>
        <option>Weekday</option>
      </select></label
    ><label
      >Generator<select
        [value]="generatorId() ?? ''"
        (change)="changeGenerator($any($event.target).value)"
      >
        <option value="">All</option>
        @for (g of generators; track g.generator_id) {
          <option [value]="g.generator_id">{{ g.name }}</option>
        }
      </select></label
    ><label
      >Unit<select
        [value]="unitId() ?? ''"
        (change)="changeUnit($any($event.target).value)"
      >
        <option value="">All</option>
        @for (u of units(); track u.unit_id) {
          <option [value]="u.unit_id">{{ u.unit_name }}</option>
        }
      </select></label
    >
    <div class="actions">
      <button class="primary app-button app-button--primary" (click)="search()">⌕&nbsp; Search</button
      ><button class="app-button app-button--secondary" (click)="reset()">Reset</button>
    </div>
  </section>
  <section class="panel analytics">
    <div
      class="view-toggle"
      style="
        position: static;
        transform: none;
        display: flex;
        justify-content: flex-end;
        margin: 0 0 0.65rem;
      "
    >
      <button
        class="app-button app-button--secondary" [class.active]="chartView() === 'graph'"
        (click)="setView('graph')"
      >
        Graph View</button
      ><button
        class="app-button app-button--secondary" [class.active]="chartView() === 'table'"
        (click)="setView('table')"
      >
        Table View
      </button>
    </div>
    <div class="kpis">
      <article class="blue">
        <span>♧</span>
        <p>
          Total Generators<strong>{{ generators.length }}</strong
          ><small>Generators</small>
        </p>
      </article>
      <article class="green">
        <span>▥</span>
        <p>
          Total Units<strong>{{ units().length }}</strong
          ><small>Units</small>
        </p>
      </article>
      <article class="purple">
        <span>▦</span>
        <p>Total Blocks<strong>96</strong><small>Blocks</small></p>
      </article>
      <article class="blue">
        <span>⌁</span>
        <p>
          Total Schedule Energy<strong>{{
            scheduleEnergy() | number: "1.2-2"
          }}</strong
          ><small>MWh</small>
        </p>
      </article>
      <article class="green">
        <span>♧</span>
        <p>
          Total Actual Energy<strong>{{
            actualEnergy() | number: "1.2-2"
          }}</strong
          ><small>MWh</small>
        </p>
      </article>
      <article class="orange">
        <span>⌁</span>
        <p>
          Avg. Deviation<strong>{{ avgDeviation() | number: "1.2-2" }} %</strong
          ><small>Schedule vs Actual</small>
        </p>
      </article>
    </div>
    @if (chartView() !== "table") {
      <div class="charts">
        <article><div #generatorChart class="highchart"></div></article>
        <article><div #unitChart class="highchart"></div></article>
      </div>
    } @else {
      <p class="table-note">
        The generator, unit, and upload detail tables below provide the table
        view.
      </p>
    }
  </section>
  <div [hidden]="chartView() === 'graph'">
    <section class="summary-grid">
      <article class="panel">
        <h2>Generator-wise Summary</h2>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Generator Name</th>
                <th>Type</th>
                <th>Capacity (MW)</th>
                <th>Schedule Energy</th>
                <th>Actual Energy</th>
                <th>Deviation (%)</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @for (g of generators; track g.generator_id; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ g.name }}</td>
                  <td>{{ g.type }}</td>
                  <td>{{ capacityFor(g) | number: "1.2-2" }}</td>
                  <td>{{ energy(capacityFor(g)) | number: "1.2-2" }}</td>
                  <td>{{ actual(capacityFor(g)) | number: "1.2-2" }}</td>
                  <td class="negative">
                    {{
                      (deviation(capacityFor(g)) / energy(capacityFor(g))) * 100
                        | number: "1.2-2"
                    }}%
                  </td>
                  <td><span>Under Schedule</span></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </article>
      <article class="panel">
        <h2>Unit-wise Details (First 10 Units)</h2>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Generator</th>
                <th>Unit Name</th>
                <th>Capacity</th>
                <th>Schedule Energy</th>
                <th>Actual Energy</th>
                <th>Deviation (%)</th>
              </tr>
            </thead>
            <tbody>
              @for (u of units(); track u.unit_id; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ generatorName(u.generator_id) }}</td>
                  <td>{{ u.unit_name }}</td>
                  <td>{{ u.rated_capacity_mw | number: "1.2-2" }}</td>
                  <td>{{ energy(u.rated_capacity_mw) | number: "1.2-2" }}</td>
                  <td>{{ actual(u.rated_capacity_mw) | number: "1.2-2" }}</td>
                  <td class="negative">
                    {{
                      (deviation(u.rated_capacity_mw) /
                        energy(u.rated_capacity_mw)) *
                        100 | number: "1.2-2"
                    }}%
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </article>
    </section>
    <section class="panel uploads">
      <h2>Uploaded Schedule Files</h2>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>File Name</th>
              <th>Generator</th>
              <th>Unit</th>
              <th>Schedule Type</th>
              <th>Upload Date &amp; Time</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (upload of uploads(); track upload.id; let i = $index) {
              <tr>
                <td>{{ i + 1 }}</td>
                <td>{{ upload.fileName }}</td>
                <td>{{ generatorName(upload.generatorId) }}</td>
                <td>{{ unitName(upload.unitId) }}</td>
                <td>{{ upload.scheduleType }}</td>
                <td>{{ upload.uploadedAt | date: "dd-MMM-yyyy HH:mm" }}</td>
                <td><span class="uploaded">Uploaded</span></td>
                <td>
                  <button
                    type="button"
                    class="view-schedule app-button app-button--secondary"
                    (click)="viewSchedule(upload)"
                  >
                    ◉ View
                  </button>
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="9" class="empty">
                  No schedule upload records found in this browser.
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  </div>
</main>
